import type { Platform, ShareContent } from '../types';
import { buildShareUrl } from '../utils/url';
import { PlatformRegistry } from './registry';

export const whatsapp: Platform = {
  id: 'whatsapp',
  name: 'WhatsApp',
  iconIndex: PlatformRegistry.whatsapp.index,
  color: PlatformRegistry.whatsapp.color,
  buildUrl: (content: ShareContent): string => {
    return buildShareUrl('https://api.whatsapp.com/send', {
      text: [content.title, content.url].filter(Boolean).join('\n'),
    });
  },
};

